module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "f-l m-r-10 mh-400 ovf-y-auto"
  }, [(_vm.isShow) ? _c('div', {
    staticClass: "m-r-10"
  }, [(_vm.currentInput.default) ? _c('h3', {
    staticClass: "m-t-0"
  }, [_vm._v(_vm._s(_vm.currentInput.default.title) + "控件传值")]) : _vm._e(), _vm._v(" "), _c('el-form', [(_vm.isShowValue) ? _c('el-form-item', {
    attrs: {
      "label": "不可见传值"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.way),
      expression: "currentInput.way"
    }],
    staticClass: "m-b-10 w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择方式"
    },
    domProps: {
      "value": (_vm.currentInput.way)
    },
    on: {
      "change": function($event) {
        _vm.changeWay()
      },
      "input": function($event) {
        _vm.currentInput.way = $event
      }
    }
  }, _vm._l((_vm.ways), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.way,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.currentInput.way == 20) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.field_default),
      expression: "currentInput.field_default"
    }],
    staticClass: "w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.currentInput.field_default)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.field_default = $event
      }
    }
  }, _vm._l((_vm.userInfos), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.currentInput.way == 10) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.field_default),
      expression: "currentInput.field_default"
    }],
    staticClass: "h-40",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.currentInput.field_default)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.field_default = $event
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._v(" "), (_vm.isShowForignKey) ? _c('el-form-item', {
    attrs: {
      "label": "筛选条件"
    }
  }, [_vm._l((_vm.currentInput.key_filter), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10"
    }, [_c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentInput.key_filter[index]),
        expression: "currentInput.key_filter[index]"
      }],
      staticClass: "w-300",
      domProps: {
        "value": (_vm.currentInput.key_filter[index])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.currentInput.key_filter,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.currentInput.key_filter[index] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "m-l-20",
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deleteKeyFilterItem(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("支持等于==, 不等于<>, 小于<逻辑判断\n        "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addKeyFilterItem()
      }
    }
  }, [_vm._v("增加")])], true) : _vm._e(), _vm._v(" "), (_vm.isShowForignKey) ? _c('el-form-item', {
    attrs: {
      "label": "连带获取联表字段并显示"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.currentInput.key_depent
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "选择字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.name),
            expression: "scope.row.name"
          }],
          attrs: {
            "placeholder": "请选择字段"
          },
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = $event
            }
          }
        }, _vm._l((_vm.major_list), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.field + '(' + item.title + ')',
              "value": item.field
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "显示名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.title),
            expression: "scope.row.title"
          }],
          attrs: {
            "placeholder": "请输入"
          },
          domProps: {
            "value": (scope.row.title)
          },
          on: {
            "input": function($event) {
              scope.row.title = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteKeyDepent(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "w-100p",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addKeyDepent
    }
  }, [_vm._v("添加一行")])]) : _vm._e(), _vm._v(" "), (_vm.isShowForignKey) ? _c('el-form-item', {
    attrs: {
      "label": "连带获取联表字段并填到本表单控件"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.currentInput.key_fillin
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "选择字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.fill_field),
            expression: "scope.row.fill_field"
          }],
          domProps: {
            "value": (scope.row.fill_field)
          },
          on: {
            "input": function($event) {
              scope.row.fill_field = $event
            }
          }
        }, _vm._l((_vm.major_list), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.field + '(' + item.title + ')',
              "value": item.field
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "选择本表单控件"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.be_fill_field),
            expression: "scope.row.be_fill_field"
          }],
          domProps: {
            "value": (scope.row.be_fill_field)
          },
          on: {
            "input": function($event) {
              scope.row.be_fill_field = $event
            }
          }
        }, _vm._l((_vm.inputList), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.default.name,
              "value": item.default.name
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteKeyFillin(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "w-100p",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addKeyFillin
    }
  }, [_vm._v("添加一行")])]) : _vm._e(), _vm._v(" "), (_vm.isShowForignKey) ? _c('el-form-item', {
    attrs: {
      "label": "配置本外键数据筛选配置（实现外键级联）"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.key_cascade.major_field),
      expression: "currentInput.key_cascade.major_field"
    }],
    staticClass: "m-b-10 w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择本表中同级字段控件"
    },
    domProps: {
      "value": (_vm.currentInput.key_cascade.major_field)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.key_cascade.major_field = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return (_vm.contrastForignKeyType(item.default.type, item.default.name)) ? _c('el-option', {
      attrs: {
        "label": item.default.name,
        "value": item.default.name
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.key_cascade.extra_field),
      expression: "currentInput.key_cascade.extra_field"
    }],
    staticClass: "m-b-10 w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择本表中外键关联字段"
    },
    domProps: {
      "value": (_vm.currentInput.key_cascade.extra_field)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.key_cascade.extra_field = $event
      }
    }
  }, _vm._l((_vm.major_list), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title,
        "value": item.field
      }
    })
  })), _vm._v(" ")]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isShowOption) ? _c('el-form-item', {
    attrs: {
      "label": "关联筛选关系"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.option_relation.major_field),
      expression: "currentInput.option_relation.major_field"
    }],
    staticClass: "w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择本表关联字段"
    },
    domProps: {
      "value": (_vm.currentInput.option_relation.major_field)
    },
    on: {
      "change": function($event) {
        _vm.changeOption()
      },
      "input": function($event) {
        _vm.currentInput.option_relation.major_field = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return (_vm.contrastOptionType(item.default.type, item.default.name)) ? _c('el-option', {
      attrs: {
        "label": item.default.name + item.default.title,
        "value": item.default.name
      }
    }) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), (_vm.isShowOption) ? _c('el-form-item', [_c('el-table', {
    attrs: {
      "data": _vm.currentInput.option_relation.relation
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "选项值",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.option_name.name) + "\n            ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "本控件可用值"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.input_id),
            expression: "scope.row.input_id"
          }],
          attrs: {
            "clearable": "",
            "multiple": "",
            "placeholder": "请选择值"
          },
          domProps: {
            "value": (scope.row.input_id)
          },
          on: {
            "input": function($event) {
              scope.row.input_id = $event
            }
          }
        }, _vm._l((_vm.curInputOption), function(item) {
          return _c('el-option', {
            attrs: {
              "label": item.name,
              "value": item.name
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteRelation(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isShowPersonOrGroup) ? _c('el-form-item', {
    attrs: {
      "label": "关联筛选关系"
    }
  }, [(_vm.currentInput.default.type === _vm.TYPE_PERSON) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.people_filter.major_field),
      expression: "currentInput.people_filter.major_field"
    }],
    staticClass: "m-b-10 w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择本表关联字段"
    },
    domProps: {
      "value": (_vm.currentInput.people_filter.major_field)
    },
    on: {
      "change": _vm.changePerson,
      "input": function($event) {
        _vm.currentInput.people_filter.major_field = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.name + item.default.title,
        "value": item.default.name
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.currentInput.default.type === _vm.TYPE_PERSON) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.people_filter.filter_field),
      expression: "currentInput.people_filter.filter_field"
    }],
    staticClass: "w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择人员表单被筛选字段"
    },
    domProps: {
      "value": (_vm.currentInput.people_filter.filter_field)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.people_filter.filter_field = $event
      }
    }
  }, _vm._l((_vm.userInfos), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  })) : _vm._e(), _vm._v(" "), _vm._v(" "), (_vm.currentInput.default.type === _vm.TYPE_STRUCT) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.struct_filter.major_field),
      expression: "currentInput.struct_filter.major_field"
    }],
    staticClass: "m-b-10 w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择本表关联字段"
    },
    domProps: {
      "value": (_vm.currentInput.struct_filter.major_field)
    },
    on: {
      "change": _vm.changePerson,
      "input": function($event) {
        _vm.currentInput.struct_filter.major_field = $event
      }
    }
  }, _vm._l((_vm.inputList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.default.name,
        "value": item.default.name
      }
    })
  })) : _vm._e(), _vm._v(" "), _vm._v(" "), (_vm.currentInput.default.type === _vm.TYPE_STRUCT) ? _c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput.struct_filter.filter_field),
      expression: "currentInput.struct_filter.filter_field"
    }],
    staticClass: "w-100p",
    attrs: {
      "clearable": "",
      "placeholder": "请选择部门表单被筛选字段"
    },
    domProps: {
      "value": (_vm.currentInput.struct_filter.filter_field)
    },
    on: {
      "input": function($event) {
        _vm.currentInput.struct_filter.filter_field = $event
      }
    }
  }, _vm._l((_vm.structList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), (_vm.isShowByDateOrOther) ? _c('el-form-item', {
    attrs: {
      "label": "大小关系限制"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.currentInput.logic_condition
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "比较逻辑"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.logic),
            expression: "scope.row.logic"
          }],
          staticClass: "w-150 m-r-10",
          attrs: {
            "placeholder": "计算公式"
          },
          domProps: {
            "value": (scope.row.logic)
          },
          on: {
            "input": function($event) {
              scope.row.logic = $event
            }
          }
        }, _vm._l((_vm.logicTypes), function(option) {
          return (_vm.configTypes(option)) ? _c('el-option', {
            key: option,
            attrs: {
              "label": option.name,
              "value": option.id
            }
          }) : _vm._e()
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "比较字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.field_name_2),
            expression: "scope.row.field_name_2"
          }],
          staticClass: "fl w-150 m-r-10",
          attrs: {
            "clearable": "",
            "placeholder": "字段二"
          },
          domProps: {
            "value": (scope.row.field_name_2)
          },
          on: {
            "change": function($event) {
              _vm.logicFiledChange()
            },
            "input": function($event) {
              scope.row.field_name_2 = $event
            }
          }
        }, _vm._l((scope.row.logicOptions2), function(option) {
          return _c('el-option', {
            attrs: {
              "label": option.title,
              "value": option.name
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteLogicCondition(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    staticClass: "w-100p",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLogicCondition
    }
  }, [_vm._v("添加一行")])]) : _vm._e(), _vm._v(" ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6029947e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/business/inputConfig/rightInputConfig.vue
// module id = 1881
// module chunks = 2